/**
 * Fills placeholder `enum: []` on string fields so package parameter schemas
 * (shipped with empty enums) resolve to organization credentials at runtime.
 */
export function injectCredentialEnums(schema, credentials) {
  if (schema == null || typeof schema !== 'object') {
    return schema;
  }
  const ids = Array.isArray(credentials)
    ? credentials.map((c) => c.id).filter(Boolean)
    : [];

  const out = JSON.parse(JSON.stringify(schema));

  const walk = (node) => {
    if (node == null || typeof node !== 'object') return;

    if (
      node.type === 'string' &&
      Array.isArray(node.enum) &&
      node.enum.length === 0
    ) {
      if (ids.length > 0) {
        node.enum = [...ids];
      } else {
        delete node.enum;
      }
    }

    if (node.properties) {
      Object.values(node.properties).forEach(walk);
    }
    if (node.items) {
      if (Array.isArray(node.items)) {
        node.items.forEach(walk);
      } else {
        walk(node.items);
      }
    }
    if (
      node.additionalProperties &&
      typeof node.additionalProperties === 'object'
    ) {
      walk(node.additionalProperties);
    }
    if (Array.isArray(node.oneOf)) node.oneOf.forEach(walk);
    if (Array.isArray(node.anyOf)) node.anyOf.forEach(walk);
    if (Array.isArray(node.allOf)) node.allOf.forEach(walk);
  };

  walk(out);
  return out;
}
